const departments = {
    leader: '責任者',
    leaders: '部門責任者',
    led_departments: '担当部門',
    edit_leaders: '責任者を設定',
    add_leader: '追加',
    remove_leader: '削除',
    no_leaders: '責任者未設定',
    local: 'ローカル設定',
    managed_members: '管理範囲のメンバー',
    leader_scope_hint: '担当部門とその配下の部門の所属を管理できます。',
    leader_permission_hint: '責任者は担当部門と配下の所属を管理でき、組織ロールや部門構造は変更できません。',
    primary_synced: '主所属部門はFeishuで管理されます。',
    status_active: '在籍',
    status_suspended: '停止中',
    status_departed: '退職',
    status_pending: '有効化待ち',
    search: '検索',
    previous_page: '前のページ',
    next_page: '次のページ',
    directory_title: '組織のメンバー',
    member_name: 'メンバー',
    search_members: '氏名またはユーザー名で検索',
    include_descendants: '下位部署を含める',
    no_members: '該当するメンバーがいません。',
    all_members: 'すべてのメンバー',
    all_departments: 'すべての部署',
    edit_member: '所属部署を編集',
    add_child: '下位部署を追加',
    expand_department: '{{name}}を展開',
    collapse_department: '{{name}}を折りたたむ',
    title: '部署',
    description: 'この組織の部署とメンバーの所属を管理します。',
    create: '部署を作成',
    edit: '部署を編集',
    name: '部署名',
    parent: '親部署',
    root: '親部署なし',
    id: '部署 ID',
    members: 'メンバーの所属部署',
    member_id: 'メンバーのユーザー ID',
    primary: '主所属部署',
    none: '未設定',
    assignments: '部署の所属一覧',
    no_assignments: '部署の所属はまだありません。',
    assignment_hint: 'ローカル部署と任意の主所属部署を指定します。ディレクトリ管理の所属は読み取り専用です。',
    empty: '部署はまだありません。',
    readonly: '部署と自分の所属を確認できます。変更は組織管理者にお問い合わせください。',
    load_error: 'データを読み込めませんでした。再試行してください。',
    mutation_error: '保存できませんでした。権限、組織への所属、部署の階層を確認してください。',
    loading: '読み込み中…',
    synced: 'ディレクトリ管理',
    choose: '部署を検索',
    organizations_title: '組織と部署',
    organizations_description: '組織を選択して部署を表示または管理します。',
    no_organizations: '組織に所属していません。組織管理者にお問い合わせください。',
    organization: '現在の組織',
    choose_organization: '組織を選択',
    delete_title: '部署を削除',
    delete_description: '「{{name}}」を削除しますか？先にメンバーと子部署を移動してください。',
};
export default Object.freeze(departments);
